import { Client } from '@langchain/langgraph-sdk';

import { createContext, useContext } from 'react';

export * from './assistants';

// ---- Named re-exports ----
export type { Assistant, Thread, ThreadState } from '@langchain/langgraph-sdk';

export class StudioClient extends Client {
  constructor(options: ConstructorParameters<typeof Client>[0]) {
    super({
      ...options,
      defaultHeaders: {
        ...options?.defaultHeaders,
        ['x-auth-scheme']: 'langsmith',
      },
    });
  }
}

export const LangGraphContext = createContext<
  | [client: StudioClient, apiUrl: string, fetch: typeof fetch]
  | [client: StudioClient, apiUrl: string, fetch: typeof fetch]
  | null
>(null);

export const useLangGraphClient = () => {
  const client = useContext(LangGraphContext);
  if (!client) {
    throw new Error(
      'useLangGraphClient must be used within a LangGraphProvider'
    );
  }

  return client;
};
